class Printer {
  static openDialog (self, data = null) {
    self.$root.printerControl.show = true
    self.$root.printerControl.data = data
  }
  static closeDialog (self) {
    self.$root.printerControl.show = false
    self.$root.printerControl.data = null
  }
}

export default Printer



// WEBPACK FOOTER //
// ./src/helper/printer.js